import { Typography } from 'antd';
import React from 'react';

const HighlightLabel = ({ children, className = '' }) => {
  return <Typography.Text className={`text-highlight fw-600 f-14 ${className}`}>{children}</Typography.Text>;
};

export default HighlightLabel;
